export const error = (state, action) => {
  state.status = "failed"
  state.error = action.error.message
  console.log("Something went wrong in store thunk: ", action)
  throw action.payload
}

export const addCasesForThunks = (builder, thunks) => {
  // This function basically creates a builder cases to run after each thunk, as
  // running callback functions when the thunk is done. They are defined in the
  // thunk files itself. Copy-paste from another thunk to replicate behavior.
  Object.values(thunks).forEach((action) => {
    builder
      .addCase(action.thunk.pending, (state) => state)
      .addCase(action.thunk.fulfilled, action.onSucceed)
      .addCase(action.thunk.rejected, error)
  })
}
